<template lang="pug">
div
  b-row(v-show="isSubmitting")
    b-col
      b-card(class="py-5")
        loading(
          :active="true"
          :is-full-page="false"
          color="#498ceb"
        )
  Form(
    v-show="!isSubmitting",
    :data="document",
    :isSubmitting="isSubmitting",
    :isEdit="true",
    :showFileUpload="false",
    :fileRequired="false",
    @submit="update"
  )
</template>

<script>
import { onMounted } from '@vue/composition-api'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import Form from '../shared/Form.vue'
import useDeclarationEdit from './useDeclarationEdit'

export default {
  components: {
    Form,
    Loading,
  },

  setup() {
    const {
      update, show, document, isSubmitting,
    } = useDeclarationEdit()

    onMounted(() => {
      show()
    })

    return {
      document,
      update,
      isSubmitting,
    }
  },
}
</script>
